namespace GeniuzPOS.InitialData {
    export class PsCashierColumns {
        static columnsKey = 'InitialData.PsCashier';
    }
}
